import { useState, useEffect } from "react";
import { navbar } from "../utils/constants";
import { IoMdMenu, IoMdClose } from "react-icons/io";
import { motion } from "framer-motion";
import Button from "./ui/Button";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <motion.header
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
      className={`sticky top-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-neutral-900/95 backdrop-blur-xl shadow-2xl shadow-primary-500/10 border-b border-neutral-800/50"
          : "bg-transparent"
      }`}
    >
      <div className="items-center justify-between pt-5 pb-3 flex px-p83">
        <motion.div
          className="flex items-center gap-3 cursor-pointer group"
          onClick={() => (window.location.href = "/")}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <motion.div
            className="relative"
            whileHover={{ rotate: [0, -10, 10, -10, 0] }}
            transition={{ duration: 0.5 }}
          >
            <img
              src="/logo.png"
              alt="Nexasoft Infotech - Software Development Company Logo"
              className="w-10 500:w-12"
              loading="eager"
            />
            <div className="absolute inset-0 bg-primary-500/20 rounded-full blur-md opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
          </motion.div>
          <span className="text-2xl 500:text-3xl font-poppins-bold bg-gradient-to-r from-white via-primary-300 to-primary-500 bg-clip-text text-transparent group-hover:from-primary-400 group-hover:via-primary-500 group-hover:to-primary-600 transition-all duration-300">
            NEXASOFT
          </span>
        </motion.div>

        {/* Desktop menu */}
        <nav className="hidden 1100:flex gap-6 1200:gap-8 items-center">
          {navbar.map(({ menu, id, href }, index) => {
            return (
              <motion.a
                href={href}
                key={id}
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="font-poppins-medium text-neutral-200 hover:text-primary-400 transition-colors duration-300 relative group px-2 py-1"
              >
                {menu}
                <motion.span
                  className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-primary-500 to-primary-600 group-hover:w-full transition-all duration-300 rounded-full"
                  initial={false}
                />
                <motion.span
                  className="absolute inset-0 bg-primary-500/5 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                  initial={false}
                />
              </motion.a>
            );
          })}
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.3 }}
          >
            <Button
              href="#contact"
              variant="primary"
              size="md"
              className="shadow-lg hover:shadow-xl hover:shadow-primary-500/30"
            >
              Contact
            </Button>
          </motion.div>
        </nav>

        {/* Mobile menu button */}
        <motion.button
          className="relative text-3xl 1100:hidden text-neutral-200 hover:text-primary-400 transition-colors p-2 rounded-lg hover:bg-neutral-800/50"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          whileTap={{ scale: 0.9 }}
          aria-label="Toggle menu"
        >
          {isMenuOpen ? <IoMdClose /> : <IoMdMenu />}
        </motion.button>
      </div>

      {/* Mobile menu */}
      {isMenuOpen && (
        <motion.nav
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.3 }}
          className="absolute top-full left-0 w-full bg-gradient-to-br from-neutral-900/98 via-neutral-900/95 to-neutral-900/98 backdrop-blur-xl shadow-2xl border-t border-neutral-800/50 1100:hidden overflow-hidden"
        >
          <div className="flex flex-col py-6 px-p83 gap-2">
            {navbar.map(({ menu, id, href }, index) => {
              return (
                <motion.a
                  href={href}
                  key={id}
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: index * 0.1 }}
                  className="text-base font-poppins-medium text-neutral-200 hover:text-primary-400 transition-colors py-3 px-4 rounded-lg hover:bg-neutral-800/50 relative group"
                  onClick={handleNavClick}
                >
                  <span className="relative z-10">{menu}</span>
                  <motion.span
                    className="absolute left-0 top-0 bottom-0 w-1 bg-primary-500 rounded-r-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                    initial={false}
                  />
                </motion.a>
              );
            })}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: navbar.length * 0.1 }}
              className="pt-4 mt-2"
            >
              <Button
                href="#contact"
                variant="primary"
                size="md"
                className="w-full shadow-lg hover:shadow-xl hover:shadow-primary-500/30"
                onClick={handleNavClick}
              >
                Contact
              </Button>
            </motion.div>
          </div>
        </motion.nav>
      )}
    </motion.header>
  );
};

export default Header;
